/**
 * Created by JackCui on 2022/1/19
 */
import {addCustomOperation} from '../jsonLogic'
import parsingSymbol from '../parsingSymbol'
import {rulesValuesRelation} from '../submitRulesValues'

// 接口返回事件类型关系
const eventTypeMap = {
  // 字段
  '2': {
    'required': 'fieldRequired',
    'readonly': 'fieldReadOnly',
    'textShow': 'fieldPlainText',
    'show': 'fieldShow'
  },
  // 列表
  '5': {
    'show': 'columnShow'
  },
  // 按钮
  '4': {
    'show': 'buttonHide'
  }
}

/**
 * 解析规则函数
 * @param expressModel
 * @param expressModelHandle 处理express
 * @returns {{}}
 */
export const parsingExpress = (expressModel, expressModelHandle) => {
  const keyMap = {
    orExpressModels: 'or',
    andExpressModels: 'and',
    express: 'and'
  }
  // 规则json的描述
  const jsonRules = {}
  // 规则中值的变量与对象和字段的关系
  const varDataMap = {}

  function parsing (model, values) {
    // 当传入的为orExpressModels andExpressModels
    if (!Array.isArray(model)) {
      for (let k in model) {
        if (!model.hasOwnProperty(k) || !model[k]) {
          continue
        }

        const expressKey = keyMap[k] || k

        if (model.express) {
          // 解析expressModel
          const {
            express,
            expressKey: {varKey, objectApiName}
          } = expressModelHandle && expressModelHandle(model['express'])

          varDataMap[varKey] = {varKey, objectApiName}
          values[expressKey] = express
          return
        } else if (model[k].length) {
          values[expressKey] = []
          parsing(model[k], values[expressKey])
        }
      }
    }

    for (let i = 0; i < model.length; i++) {
      values[i] = {}
      parsing(model[i], values[i])
    }
  }

  parsing(expressModel, jsonRules)
  return {jsonRules, varDataMap}
}

/**
 * 规则数据处理
 * @param code
 * @param modelMap
 * @returns {{ruleMode: *, eventsMode: *}}
 */
export const ruleModelHandle = (code, modelMap) => {
  const {eventDescModels, expressModel, ruleValueParamModels} = modelMap[code]
  const eventsMode = eventDescModels.map(
    ({elementApiName, elementType, objectApiName, eventType, ruleErrorCodeList}) => {
      return {
        objectApiName: objectApiName,
        fieldApiName: elementApiName,
        eventType: eventTypeMap[elementType][eventType],
        ruleErrorCodeList
      }
    }
  )
  const ruleMode = parsingExpress(expressModel, parsingSymbol)
  // 解析规则中的ruleValueParamModels 并注册到Map中
  // TODO 保存值时提交给后端的参数
  rulesValuesRelation(ruleValueParamModels)
  return {eventsMode, ruleMode}
}

/**
 * 处理后台接口返回数据统一数据结构
 * @param bandObjectRuleRelModels
 * @param ruleModelMap
 */
export const dataModelHandle = ({bandObjectRuleRelModels, ruleModelMap} = {}) => {
  const pageDriven = []

  if (!bandObjectRuleRelModels) {
    return pageDriven
  }

  bandObjectRuleRelModels.forEach(({bandObjectModel, ruleDetailCodeList}) => {
    const model = {
      bindModel: {},
      eventsMode: [],
      ruleMode: []
    }
    const {bandType, elementApiName, objectApiName} = bandObjectModel
    model.bindModel = {
      bandType, elementApiName, objectApiName
    }

    ruleDetailCodeList.forEach(v => {
      const {eventsMode, ruleMode} = ruleModelHandle(v, ruleModelMap)
      model.eventsMode = eventsMode
      model.ruleMode = ruleMode
    })

    pageDriven.push(model)
  })

  return pageDriven
}

/**
 * 处理自定义页面规则数据结构
 * @param pageDriven
 * @returns {*}
 */
export const customDataModelHandle = (pageDriven = []) => {
  return pageDriven.map(v => {
    const {bindModel, ruleMode} = v

    if (!bindModel.bindType) {
      bindModel.bindType = 'changeValue'
      bindModel.type = 'custom'
    }

    return {
      ...v,
      ruleMode: parsingExpress(
        ruleMode,
        (
          {
            objectApiName,
            fieldApiName,
            fieldType,
            symbol,
            value
          }
        ) => {
          const varKey = `${objectApiName}_${fieldApiName}`
          const varValue = {'var': varKey}

          if (typeof symbol === 'function') {
            addCustomOperation(fieldType, symbol)
          }

          return {
            express: {
              [`${fieldType}-${symbol.toString()}`]: [varValue, value]
            },
            expressKey: {
              varKey,
              objectApiName
            }
          }
        }
      )
    }
  })
}
